import { Subject } from 'rxjs';

export abstract class AbstractService {
  protected destroyed$ = new Subject<void>();

  destroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
